import { useTranslation } from 'react-i18next'

export function RouteLoader() {
  const { t } = useTranslation()
  return <div className="p-8 text-sm text-gray-500">{t('loading')}</div>
}
